import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {showAppLoader, hideAppLoader, showOverlay} from  '../../Shared/Loader/LoaderSlice';
import {getTvCustomerList, setRedirectUrl, reportDWH} from './TvActivationCodeRecoveryBlockSlice';
import CustomerList from './CustomerList';
import RecoveryButton from './RecoveryButton';
import SuccessMessage from './SuccessMessage';
import ErrorMessage from './ErrorMessage';
import EmptyListMessage from './EmptyListMessage';
import SubscriptionInformation from './SubscriptionInformation';

 const ActivationCodeRecoveryFlow = (props, context) => {

    useEffect(() => {
        const fetchData = async () => {
            try {
                props.setRedirectUrl(props.contentData.exitFlowPage?.value?.url);
                await props.getTvCustomerList();
                props.reportDWH({ actionType: 'TV Code Page', status: 'Ongoing', messageText: 'TV Code Page Displayed' });
                
            } catch (error) {
                console.error("שגיאה בקבלת הנתונים", error);
            }
        };
        fetchData();
    }, []);

    return (
      <div className="tv-activation-code-recovery-flow">
        <div className="container">
           { props.TvActivationCodeRecovery.showCustomerList && <CustomerList/>}
           {/* { props.TvActivationCodeRecovery.showRecoveryButton && <RecoveryButton/>} */}
           { props.TvActivationCodeRecovery.showRecoveryButton && <SubscriptionInformation/>}
           { props.TvActivationCodeRecovery.showSuccessMessage && <SuccessMessage/>}
           { props.TvActivationCodeRecovery.showErrorMessage && <ErrorMessage/>}
           { props.TvActivationCodeRecovery.showEmptyListMessage && <EmptyListMessage/>}
        </div>
    </div>
    ) ;
  };
  
  const mapStateToProps = (state) => {  return { TvActivationCodeRecovery: state.TvActivationCodeRecovery, loginData: state.authentication.loginData }; };
  const mapDispatchToProps = { getTvCustomerList, showAppLoader, hideAppLoader,reportDWH ,showOverlay, setRedirectUrl };
  export default connect(mapStateToProps, mapDispatchToProps)(ActivationCodeRecoveryFlow);
